export default function ProductIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.95898 5.925C5.95898 4.93089 6.76487 4.125 7.75898 4.125H13.3256C14.3198 4.125 15.1257 4.93089 15.1257 5.925V10.5417H7.75899C6.76487 10.5417 5.95898 9.73578 5.95898 8.74167V5.925Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4.125 12.3417C4.125 11.3475 4.93089 10.5417 5.925 10.5417H11.4583V17.875H5.925C4.93089 17.875 4.125 17.0691 4.125 16.075V12.3417Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.459 10.5417H16.9923C17.9864 10.5417 18.7923 11.3475 18.7923 12.3417V16.075C18.7923 17.0691 17.9864 17.875 16.9923 17.875H11.459V10.5417Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M15.125 10.5417V13.2917" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M7.79102 10.5417V13.2917" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M10.541 4.125V6.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
